export type Testimonial = {
  quote: string
  author: string
  role: string
  avatar?: string
}

/**
 * Intentionally empty. Memory Care Activity Ready has no buyers yet, and the
 * barre quotes were sample copy. App.tsx hides both review blocks while these
 * lists are empty. Add real buyer reviews (with permission) before running
 * traffic. US FTC rules prohibit fabricated reviews. Keep reviews free of
 * claims about behavior, memory or health.
 */
export const shortTestimonials: Testimonial[] = []

export const moreTestimonials: Testimonial[] = []
